const CONSTANTS = {
  CART_ACTIVE: 'CART:ACTIVATE',
  CART_UPDATE: 'CART:UPDATE',
  CART_ADD: 'CART:ADD',
  CART_FAIL: 'CART:FAIL',
  CART_REMOVEITEM: 'CART:REMOVEITEM',
  CART_CLEAR: 'CART:CLEAR',
  CART_OPEN_MINICART: 'CART:OPEN:MINICART',
  CART_UPDATING: 'CART:UPDATING',
  QUICKADD_OPEN: 'QUICKADD:OPEN',
  QUICKADD_CLOSE: 'QUICKADD:CLOSE',
  LOADING: 'LOADING',
  TOAST_DISPATCH: 'TOAST:DISPATCH',
  TOAST_SHOW: 'TOAST:SHOW',
  TOAST_HIDE: 'TOAST:HIDE',
  TOAST_DISMISS: 'TOAST:DISMISS',
  PORTALS: {
    LOADING: 'data-app-layer-portal="loading"',
    TOAST: 'data-app-layer-portal="toast"',
    CART_COUNT_BADGE: 'data-app-layer-portal="cart-count-badge"',
    CART_COUNT_BADGE_2: 'data-app-layer-portal="cart-count-badge-2"',
    PRODUCT_RECOMMENDATIONS: 'data-app-layer-portal="product-recommendations"',
    CART_RECOMMENDATIONS: 'data-app-layer-portal="cart-recommendations"',
    MINICART: 'data-app-layer-portal="minicart"',
    QUICKADD: 'data-app-layer-portal="quickadd"',
    SEARCH_INPUT: 'data-app-layer-portal="search-input"',
    SEARCH_SUBMIT: 'data-app-layer-portal="search-submit"',
    SEARCH_TRENDING: 'data-app-layer-portal="search-trending"',
    SEARCH_SUGGESTIONS: 'data-app-layer-portal="search-suggestions"',
    SEARCH_COLLECTIONS: 'data-app-layer-portal="search-collections"',
    SEARCH_PAGES: 'data-app-layer-portal="search-pages"',
    SEARCH_PRODUCTS_COUNT: 'data-app-layer-portal="search-products-count"',
    SEARCH_PRODUCTS: 'data-app-layer-portal="search-products"',
    SEARCH_FILTERS: 'data-app-layer-portal="search-filters"',
    SEARCH_FILTER_COUNT: 'data-app-layer-portal="search-filter-count"',
    SEARCH_FILTERED_PRODUCTS: 'data-app-layer-portal="search-filtered-products"',
    SEARCH_SORT_BY: 'data-app-layer-portal="search-sort-by"',
    RECENTLY_VIEWED: 'data-app-layer-portal="recently-viewed"',
    SEARCH_FILTER_QUICK_REMOVES: 'data-app-layer-portal="search-filter-quick-removes"',
    COUNTDOWN_TIMER: 'data-app-layer-portal="countdown-timer"',
    FOUR_THREE_WIDGET: 'data-app-layer-portal="four-three-widget"',
  }
};

export default CONSTANTS;